"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Box_1 = __importDefault(require("@mui/material/Box"));
var makeAnimationWrapperStyling_1 = __importDefault(require("./makeAnimationWrapperStyling"));
var AnimationWrapper = function (_a) {
    var children = _a.children, effect = _a.effect, delay = _a.delay, animationTime = _a.animationTime;
    return ((0, jsx_runtime_1.jsx)(Box_1.default, { css: (0, makeAnimationWrapperStyling_1.default)({
            effect: effect,
            delay: delay,
            animationTime: animationTime,
        }), children: children }));
};
exports.default = AnimationWrapper;
//# sourceMappingURL=AnimationWrapper.js.map